import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class DualSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nav1: null,
      nav2: null,
    };
  }

  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });
  }

  render() {
    const { t } = this.props;
    const items = t("home.dualSlider.items", { returnObjects: true });

    const images = [
      require("../../images/iso-9001.png"),
      require("../../images/iso-22000.png"),
      require("../../images/best-pack.png"),
      require("../../images/brc-logo.png"),

    
    ];

    const settings = {
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
    };

    return (
      <>
        <Slider
          {...settings}
          className="project-list btn-style-1 icon-2"
          asNavFor={this.state.nav2}
          ref={(slider) => (this.slider1 = slider)}
        >
          {items.map((item, index) => (
            <div
              className="item"
              key={index}
              onClick={() => this.slider2.slickGoTo(index)}
            >
              <div className="project-owbx">
                <i className={item.icon}></i>
                <h4 className="title">{item.text}</h4>
              </div>
            </div>
          ))}
        </Slider>

        <Slider
          {...settings}
          className="primary"
          asNavFor={this.state.nav1}
          ref={(slider) => (this.slider2 = slider)}
        >
          {items.map((item, index) => (
            <div className="item" key={index}>
              <div className="row align-items-center">
                <div className="col-lg-6 col-md-6 m-b30">
                  <div className="our-story">
                    {item.shortTitle && <span>{item.shortTitle}</span>}
                    <h2 className="title">{item.title}</h2>
                    {item.subTitle && (
                      <h4 className="title">{item.subTitle}</h4>
                    )}
                    <p>{item.description}</p>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 m-b30">
                  <img
                    src={images[index]}
                    className="radius-sm"
                    alt={item.title}
                  />
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </>
    );
  }
}

export default withTranslation()(DualSlider);
